<template>
  <div
    v-if="type === 'date'"
    class="inputField"
  >
    <label class="textBold">
      {{ $t("bnpl:special_field.customer.date_of_birth.label") }}
    </label>
    <InputCalendar
      v-model="value"
      :default-value="modelValue"
      @input="onInput"
    />
  </div>
  <div
    v-else
    class="inputField validator-field"
  >
    <label class="textBold">
      {{ label }}
    </label>
    <input
      v-model="value"
      class="textInput"
      :disabled="disabled"
      @input="onInput"
    >
  </div>
</template>

<script setup>

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: [String, Date],
    required: true,
  },
  label: String,
  disabled: Boolean,
  type: String,
});

const value = ref(null)

function onInput() {
  emit('update:modelValue', value.value);
}

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue) {
      value.value = props.modelValue;
    }
  },
  { immediate: true }
)
</script>
